import React, { useEffect, useRef, useState } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { ChevronDown } from "lucide-react";

import logo2 from "../../../Images/Group 1171279193.png";
import logo3 from "../../../Images/darklogo.png";
import logon from "../../../Images/darklogonn.png";
import logown from "../../../Images/logown.png";

import avatar from "../../../Images/avatar.jpg";
import settings from "../../../Images/fi_318477.png";

import Sidebar2 from "../../../Layout/Sidebar2";
import HomeService from "../../../Services/HomeService";

export function WinnersHeaderBlue() {
  const [scrolled, setScrolled] = useState(false);
  const [show, setShow] = useState(false);

  const [profileData, setProfileData] = useState({});

  const [dark, setDark] = useState(
    document.documentElement.classList.contains("dark"),
  );

  const [citiesWithCityDetails, setCitiesWithCityDetails] = useState([]);
  const [isCitySubMenuOpen, setIsCitySubMenuOpen] = useState(false);
  const location = useLocation();
  const citySubmenuRef = useRef();
  const navigate = useNavigate();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        citySubmenuRef.current &&
        !citySubmenuRef.current.contains(event.target)
      ) {
        setIsCitySubMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  useEffect(() => {
    const observer = new MutationObserver(() => {
      setDark(document.documentElement.classList.contains("dark"));
    });

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["class"],
    });

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);

    onScroll();

    window.addEventListener("scroll", onScroll, {
      passive: true,
    });

    return () => {
      window.removeEventListener("scroll", onScroll);
    };
  }, []);

  useEffect(() => {
    getLoginProfile();
  }, []);

  const getLoginProfile = async () => {
    try {
      const res = await HomeService.getLoginProfile();

      if (res?.status) {
        setProfileData(res.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const sidebarfunc = () => {
    setShow(true);
  };

  const sidebarfunc2 = () => {
    setShow(false);
  };

  // console.log("citiesWithCityDetails", citiesWithCityDetails);

  const fetchCitiesWithCityDetails = async () => {
    try {
      const res = await HomeService.getCitiesWithCityDetails();
      console.log("city details header", res);
      if (res?.status) {
        setCitiesWithCityDetails(res?.data);
      } else {
        console.log(res);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchCitiesWithCityDetails();
  }, []);

  return (
    <>
      <header className="wsh-header_blue" data-scrolled={scrolled}>
        {/* Logo */}
        <div className="wsh-logo_blue">
          <img
            src={dark ? logown : logo2}
            // src={dark ? logo3 : logon}
            // src={logon}
            alt="logo"
            className="wsh-logo-img_blue"
          />
        </div>

        {/* Navigation */}
        <nav className="wsh-nav_blue">
          <NavLink to="/" className="wsh-link_blue">
            Home
          </NavLink>

          <NavLink to="/propertylist" className="wsh-link_blue">
            Properties
          </NavLink>

          <NavLink to="/communitylist" className="wsh-link_blue">
            Community
          </NavLink>

          <NavLink to="/aboutus" className="wsh-link_blue">
            About
          </NavLink>

          <NavLink to="/blog" className="wsh-link_blue">
            Blog
          </NavLink>

          <NavLink to="/career" className="wsh-link_blue">
            Careers
          </NavLink>

          <div
            ref={citySubmenuRef}
            style={{
              position: "relative",
              display: "inline-flex",
              alignItems: "center",
            }}
          >
            <span
              className="wsh-link_blue"
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "4px",
                cursor: "pointer",
              }}
              onClick={() => {
                setIsCitySubMenuOpen(!isCitySubMenuOpen);
              }}
            >
              Cities
              <ChevronDown size={14} />
            </span>

            {isCitySubMenuOpen && (
              <div
                style={{
                  minWidth: "150px",
                  backgroundColor: "#003466",
                  position: "absolute",
                  top: "30px",
                  right: "-45px",
                  borderRadius: "5px",
                  padding: "10px 4px",
                  zIndex: "1223",
                  color: "#fff",
                }}
              >
                {citiesWithCityDetails?.length === 0 ? (
                  <p
                    style={{
                      margin: "5px 5px",
                      fontWeight: "600",
                    }}
                  >
                    No City Found
                  </p>
                ) : (
                  citiesWithCityDetails?.map((e, i) => {
                    return (
                      <p
                        key={i}
                        style={{
                          margin: "5px 5px",
                          fontWeight: "500",
                          cursor: "pointer",
                          fontSize: "15px",
                        }}
                        onClick={() => {
                          const city = e?.cityData?.name
                            ?.trim()
                            .replace(/\s+/g, "-");
                          navigate(`/city/${city}`, {
                            state: { id: e?.cityData?._id },
                          });
                          setIsCitySubMenuOpen(false);

                        }}
                      >
                        {e?.cityData?.name}
                        <hr style={{ borderTop: "2px solid white" }} />
                      </p>
                    );
                  })
                )}
              </div>
            )}
          </div>
        </nav>

        {/* Right Side */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "18px",
          }}
        >
          {/* Logged In User */}
          {profileData?._id ? (
            <div className="admin_nav_data">
              <div
                className="admin_img"
                style={{
                  borderRadius: "50%",
                  overflow: "hidden",
                }}
              >
                <img
                  src={profileData?.image || avatar}
                  alt="profile"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                  }}
                />
              </div>

              <NavLink
                to="/profile"
                style={{
                  textDecoration: "none",
                }}
              >
                <div className="admin_name_div">
                  <p className="admin_name_para">{profileData?.fullName}</p>

                  <p className="admin_email">{profileData?.email}</p>
                </div>
              </NavLink>

              <NavLink to="/profile">
                <div className="settings-img">
                  <img
                    src={settings}
                    alt="settings"
                    style={{
                      width: "16px",
                    }}
                  />
                </div>
              </NavLink>
            </div>
          ) : (
            <NavLink
              to="/profile"
              className="wsh-cta_blue"
              style={{
                textDecoration: "none",
              }}
            >
              Join Now
            </NavLink>
          )}

          {/* Sidebar Menu Button */}
          <div id="menu_bar_new">
            <div onClick={sidebarfunc} className="menu_bar_wrapper_div">
              <svg width="18" height="18" viewBox="0 0 23 23" fill="none">
                <path
                  d="M0.5 0.5H4.5V4.5H0.5V0.5ZM0.5 9.5H4.5V13.5H0.5V9.5ZM0.5 18.5H4.5V22.5H0.5V18.5ZM9.5 0.5H13.5V4.5H9.5V0.5ZM9.5 9.5H13.5V13.5H9.5V9.5ZM9.5 18.5H13.5V22.5H9.5V18.5ZM18.5 0.5H22.5V4.5H18.5V0.5ZM18.5 9.5H22.5V13.5H18.5V9.5ZM18.5 18.5H22.5V22.5H18.5V18.5Z"
                  fill="currentColor"
                />
              </svg>
            </div>
          </div>
        </div>
      </header>

      {show && <Sidebar2 sidebarfunc2={sidebarfunc2} />}
    </>
  );
}
